import React, { useState } from 'react';
import { X } from 'lucide-react';
import { countWords, replaceWords } from '../../lib/replaceWords';

/**
 * «Найти и заменить» по расшифровке: целые слова, без учёта регистра. «Заменить все»
 * сразу сохраняет — сервер помечает правку как replace_all, это самый частый случай
 * для будущего словаря замен («один эс ерпэ» → «1С ERP»).
 */
export default function FindReplaceBar({ text, onReplaceAll, onClose, saving }) {
  const [find, setFind] = useState('');
  const [replacement, setReplacement] = useState('');
  const count = countWords(text, find);
  const same = find.trim() === replacement.trim();

  const apply = () => {
    const { text: next, count: n } = replaceWords(text, find, replacement.trim());
    if (n) onReplaceAll(next, n);
  };

  const input = 'min-w-0 flex-1 rounded-[8px] bg-paper-bg px-[10px] py-[6px] text-[13px] text-paper-ink outline-none '
    + 'focus:ring-1 focus:ring-paper-accent';

  return (
    <div className="mb-3 flex flex-wrap items-center gap-2 rounded-panel bg-paper-panel p-2">
      <input aria-label="Найти" placeholder="Найти (ё и е различаются)" value={find}
             onChange={(e) => setFind(e.target.value)} className={input} />
      <input aria-label="Заменить на" placeholder="Заменить на" value={replacement}
             onChange={(e) => setReplacement(e.target.value)} className={input} />
      <span className="text-[12px] text-paper-ink-3" data-testid="find-count">
        {find.trim() ? `найдено: ${count}` : ''}
      </span>
      <button type="button" onClick={apply} disabled={!count || same || saving}
              className="rounded-[8px] bg-paper-accent px-[10px] py-[6px] text-[12px] font-semibold text-white
                         hover:bg-paper-accent-hover disabled:opacity-50">
        Заменить все
      </button>
      <button type="button" onClick={onClose} aria-label="Закрыть поиск"
              className="rounded-[8px] p-[6px] text-paper-ink-3 hover:bg-paper-bg">
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
